import { select, selectAll } from "../core/dom";

const OPEN_CLASS = "is-open";

export function initFaq(): void {
  const items = selectAll<HTMLElement>("#faq .faq-item");
  if (items.length === 0) return;

  const closeItem = (item: HTMLElement): void => {
    const button = select<HTMLButtonElement>(".faq-question", item);
    const answer = select<HTMLElement>(".faq-answer", item);

    item.classList.remove(OPEN_CLASS);
    button?.setAttribute("aria-expanded", "false");
    if (answer) answer.style.height = "0px";
  };

  const openItem = (item: HTMLElement): void => {
    const button = select<HTMLButtonElement>(".faq-question", item);
    const answer = select<HTMLElement>(".faq-answer", item);
    if (!button || !answer) return;

    item.classList.add(OPEN_CLASS);
    button.setAttribute("aria-expanded", "true");
    answer.style.height = `${answer.scrollHeight}px`;
  };

  for (const item of items) {
    const button = select<HTMLButtonElement>(".faq-question", item);
    const answer = select<HTMLElement>(".faq-answer", item);
    if (!button || !answer) continue;

    button.setAttribute("aria-expanded", String(item.classList.contains(OPEN_CLASS)));

    if (item.classList.contains(OPEN_CLASS)) {
      answer.style.height = `${answer.scrollHeight}px`;
    }

    button.addEventListener("click", () => {
      const shouldOpen = !item.classList.contains(OPEN_CLASS);
      items.forEach(closeItem);
      if (shouldOpen) openItem(item);
    });
  }

  window.addEventListener("resize", () => {
    const openItemElement = items.find((item) => item.classList.contains(OPEN_CLASS));
    const answer = openItemElement ? select<HTMLElement>(".faq-answer", openItemElement) : null;

    if (answer) answer.style.height = `${answer.scrollHeight}px`;
  });
}
